/** @jsxImportSource @emotion/react */
import PropTypes from 'prop-types';
import { css } from '@emotion/react';

import { pillStyles } from './Pill.styles';

const Pill = ({
  styles = css``, background = '#F5942E', width = 'fit-content', children,
}) => (
  <span css={[pillStyles(width, background), styles]}>{children}</span>
);

Pill.propTypes = {
  styles: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({}), PropTypes.func]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  background: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default Pill;
